var app_ajax = null;
(function ($) {
  app_ajax = function (_url, _template_name) {
    var self = this;
    self.url = _url;
    self.doing_ajax = false;
    self.template = wp.template(_template_name);
    self.current_template = null;
    self.scrollPosition = 0;

    self.defaultTitle = $(document).prop("title");
    self.defaultLocation = window.location;
    self.bf = "forward";
    self.current_id = 0;
    self.timer = null;
    self.offsetTop = 0;

    self.cache = [];

    // Click listener for closing modal when clicking outside
    $(document).on("click", function (event) {
      if (
        self.current_template &&
        $("body").hasClass("as-is-open") &&
        !$(event.target).closest(self.current_template).length
      ) {
        self.close(event);
      }
    });

    self.do_ajax = function (id, offsetTop) {
      if (!undef(id) && !self.doing_ajax) {
        self.current_id = id;
        self.doing_ajax = true;
        self.reset_template();
        self.offsetTop = offsetTop ? offsetTop : 0;

        // if (typeof self.cache[id] !== "undefined") {
        //     console.log(self.cache);
        //   self.ajax_complete(self.cache[id]);
        // } else {
        // }  
        $.getJSON(self.url + "/" + id, self.ajax_complete.bind(self));
      }
    };

    self.ajax_complete = function (data) {
      self.doing_ajax = false;

      
      if (data) {
        self.cache[data.ID] = data;
        self.bf = "backward";
        self.scrollPosition = $(window).scrollTop();

        console.log(data);
        self.current_template = $("<div/>", {
          class: "mustache-single-apartment-wrapper",
          html: self.get_template(data),
        });

        // Only bind close to the top-level close button (not the one inside signup form)
        self.current_template.find("> a.sa-close-btn").on("click", self.close);

        // Signup form toggle - replace content with form
        self.current_template
          .find(".sa-signup-toggle")
          .on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.current_template.find(".mustache-single-apartment").hide();
            self.current_template.find("> a.sa-close-btn").hide();
            self.current_template.find(".sa-signup-form").show();
            $(window).trigger("resize");
            if (window.parent && window.parent !== window) {
              try {
                window.parent.postMessage("scrollToIframe", "*");
              } catch (err) {}
            }
          });

        // Close from signup form goes back to apartment view
        self.current_template
          .find(".sa-signup-form > .sa-close-btn")
          .on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.current_template.find(".sa-signup-form").hide();
            self.current_template.find(".mustache-single-apartment").show();
            self.current_template.find("> a.sa-close-btn").show();
            $(window).trigger("resize");
            if (window.parent && window.parent !== window) {
              try {
                window.parent.postMessage("scrollToIframe", "*");
              } catch (err) {}
            }
          });

        self.current_template
          .find("#rebla-signup-form")
          .on("submit", function (e) {
            e.preventDefault();
            var $form = $(this);
            var $btn = $form.find('button[type="submit"]');
            var $msg = $form.find(".sa-signup-message");

            $btn.prop("disabled", true).text("Skickar...");
            $msg.hide();

            $.ajax({
              url: gas.rest_url + "gf-apartment-selector/v1/signup/",
              method: "POST",
              contentType: "application/json",
              data: JSON.stringify({
                firstName: $form.find('[name="firstName"]').val(),
                lastName: $form.find('[name="lastName"]').val(),
                email: $form.find('[name="email"]').val(),
                phone: $form.find('[name="phone"]').val(),
                zip: $form.find('[name="zip"]').val(),
                birthYear: $form.find('[name="birthYear"]').val(),
                propertyNumber: $form.find('[name="propertyNumber"]').val(),
                acceptPrivacyPolicy: $form
                  .find('[name="acceptPrivacyPolicy"]')
                  .is(":checked"),
              }),
              success: function (res) {
                $form.html(
                  '<p class="sa-signup-success">' + res.message + "</p>"
                );
              },
              error: function (xhr) {
                var msg =
                  xhr.responseJSON && xhr.responseJSON.message
                    ? xhr.responseJSON.message
                    : "Något gick fel. Försök igen.";
                $msg.text(msg).show();
                $btn.prop("disabled", false).text("Skicka");
              },
            });
          });

        // IMPORTANT: tell parent to save its current scrollY and scroll to the
        // iframe BEFORE we mutate the body. As soon as we add `as-is-open` the
        // iframe shrinks (everything but the modal hidden), parent body
        // shrinks, and the browser clamps parent.scrollY downward — by the
        // time `scrollToIframe` arrives the original position is already lost.
        if (window.parent && window.parent !== window) {
          try {
            console.log("[iframe-child] ajax_complete: posting scrollToIframe (pre-mutation)");
            window.parent.postMessage("scrollToIframe", "*");
          } catch (err) {}
        }

        $("body").addClass("as-is-open");
        $("body").append(self.current_template);
        $(window).trigger("resize");
      }
    };

    self.close = function (event) {
      if (event) event.stopImmediatePropagation();
      self.reset_template();
    };

    self.changeUrl = function (id, page, url) {
      if (typeof history.pushState !== "undefined") {
        history.pushState({ id: id }, page, url);
        $(document).prop("title", page);
        $(window).on("popstate", self.history);
      } else {
        console.log("cant change url... old browser");
      }
    };

    self.get_template = function (data) {
      return self.template(data);
    };

self.reset_template = function () {
  $("body").removeClass("as-is-open");
  if (self.current_template !== null) {
    self.current_template.remove();
  }
  self.current_template = null;
  // Synchronously notify parent of the new (larger) body height BEFORE asking
  // it to restore scroll, otherwise the scrollTo target may be clamped by the
  // still-small iframe height.
  if (window.parent && window.parent !== window) {
    try {
      var h = document.body.scrollHeight;
      console.log("[iframe-child] reset_template: posting documentHeight", h, "+ restoreScroll");
      window.parent.postMessage("documentHeight:" + h, "*");
      window.parent.postMessage("restoreScroll", "*");
    } catch (err) {}
  }
  $(window).trigger("resize");
};

    self.history = function (event) {
      event.preventDefault();
      if (
        typeof event === "object" &&
        typeof event.type !== "undefined" &&
        event.type === "popstate"
      ) {
        switch (self.bf) {
          case "forward":
            self.do_ajax(self.current_id);
            break;
          case "backward":
            self.close_template(event);
            break;
        }
      }
    };

    self.close_template = function () {
      self.current_template.fadeOut(500, function () {
        self.bf = "forward";
        $(document).prop("title", self.defaultTitle);
        self.changeUrl(1, self.defaultTitle, self.defaultLocation);
        $("body").removeClass("as-is-open as-closing");
        self.reset_template();

        $("html, body").stop().animate(
          {
            scrollTop: self.scrollPosition,
          },
          0
        );
      });
    };

    return self;
  };
})(jQuery, window, document);
